<template>
    <template v-for="i of 3" :key="i">
        <div class="product__card" style="margin-bottom: 30px">
            <div class="product__card-top" style="padding-top: 30px">
                <h5
                    class="h5 product__card-name skeleton-box"
                    style="width: 100%; min-height: 16px"
                ></h5>
                <h5
                    class="h5 product__card-name skeleton-box"
                    style="width: 40%; min-height: 16px"
                ></h5>
            </div>
            <div
                class="product__card-picture"
                style="height: 250px; max-height: 250px"
            ></div>
            <div class="product__card-bottom" style="margin-top: -33px">
                <div class="product__card-features skeleton-box">
                    <div class="features__list skeleton-box"></div>
                </div>

                <div
                    class="product__card-stock skeleton-box"
                    style="width: 60%; height: 16px"
                >
                    <div class="stock__color" style="visibility: hidden"></div>
                </div>
                <div
                    class="product__card-stock skeleton-box"
                    style="width: 90%; height: 25px"
                >
                    <div class="stock__color" style="visibility: hidden"></div>
                </div>
            </div>
        </div>
    </template>
</template>

<script lang="ts">
import { Skeleton } from "./skeleton";
export default Skeleton;
</script>
